import type { TtqLlmMode, TtqModelInvocationOptions } from '@kelilearning/psycheflow-contracts';

import {
  formatTtqModelLabel,
  getTtqModelBrandIcon,
  normalizeTtqModelId,
} from '../../utils/ttqModelBrand';

export type TtqWorkbenchModelOption = {
  id: string;
  provider: string;
  model: string;
  mode?: TtqLlmMode;
  label: string;
  subtitle?: string;
  selectable: boolean;
  recommended?: boolean;
};

export const DEFAULT_TTQ_WORKBENCH_MODEL_ID = 'deepseek-v4-pro';

const STORAGE_KEY = 'psycheflow-webapp2.ttq.workbenchModelId';

/** 品题工作台可选模型（与 AppFunctor ttqModelRouter / FC 入参对齐） */
export const TTQ_WORKBENCH_MODEL_OPTIONS: TtqWorkbenchModelOption[] = [
  {
    id: 'deepseek-v4-pro',
    provider: 'deepseek',
    model: 'deepseek-v4-pro',
    mode: 'reasoner',
    label: 'DeepSeek V4 Pro',
    subtitle: '默认品题模型',
    selectable: true,
    recommended: true,
  },
  {
    id: 'deepseek-v4-flash',
    provider: 'deepseek',
    model: 'deepseek-v4-flash',
    mode: 'chat',
    label: 'DeepSeek V4 Flash',
    subtitle: '更快更省',
    selectable: true,
  },
  {
    id: 'qwen3.7-max',
    provider: 'qwen',
    model: 'qwen3.7-max',
    mode: 'reasoner',
    label: 'Qwen 3.7 Max',
    subtitle: '纯文本最强 · 非多模态场景',
    selectable: true,
  },
  {
    id: 'qwen-plus',
    provider: 'qwen',
    model: 'qwen-plus',
    mode: 'reasoner',
    label: 'Qwen Plus',
    subtitle: '通义通用文本',
    selectable: true,
  },
  {
    id: 'qwen3.7-plus',
    provider: 'qwen',
    model: 'qwen3.7-plus',
    mode: 'reasoner',
    label: 'Qwen3.7 Plus',
    subtitle: '强多模态场景',
    selectable: true,
  },
];

export function getTtqWorkbenchModelOption(id?: string | null): TtqWorkbenchModelOption {
  const normalized = normalizeTtqModelId(id) || String(id || '').trim();
  const matched = TTQ_WORKBENCH_MODEL_OPTIONS.find((item) => (
    item.id === normalized
    || item.model === normalized
    || normalizeTtqModelId(item.model) === normalized
  ));
  return matched || TTQ_WORKBENCH_MODEL_OPTIONS.find((item) => item.id === DEFAULT_TTQ_WORKBENCH_MODEL_ID)!;
}

export function toTtqModelInvocation(option: TtqWorkbenchModelOption): TtqModelInvocationOptions {
  return {
    provider: option.provider,
    model: option.model,
    mode: option.mode,
  };
}

export function readStoredTtqWorkbenchModelId(): string {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const option = getTtqWorkbenchModelOption(raw);
    return option.selectable ? option.id : DEFAULT_TTQ_WORKBENCH_MODEL_ID;
  } catch {
    return DEFAULT_TTQ_WORKBENCH_MODEL_ID;
  }
}

export function writeStoredTtqWorkbenchModelId(id: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, getTtqWorkbenchModelOption(id).id);
  } catch {
    // ignore quota / private mode
  }
}

export function resolveTtqWorkbenchModelDisplay(option: TtqWorkbenchModelOption) {
  return {
    label: option.label || formatTtqModelLabel(option.model),
    iconUrl: getTtqModelBrandIcon(option.provider, option.model),
  };
}
